export default __webpack_public_path__ + "static/illustration-17353b18f0a4cb09c5753e3e8cbd80dc.svg";